import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field } from 'redux-form';

import { getText } from 'misc/helpers';

class AgreementCheckbox extends Component {
    render = () => {
        return (
            <label className="checkbox checkbox-agreement">
                {getText('Missing', 'Jag accepterar')}{' '}
                <Link to={this.props.backUrl}>{getText('Missing', 'villkoren & integritetspolicy')}</Link>
                <Field name="agree" component="input" type="checkbox" onChange={this.props.onChange} />
                <span className="checkmark agreement-checkmark" />
            </label>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

AgreementCheckbox = connect(mapStateToProps)(AgreementCheckbox);

export default AgreementCheckbox;



// WEBPACK FOOTER //
// ./src/components/shared/form/AgreementCheckbox.js